import { useSnackbarContext } from "@inductiveautomation/ws-components";
import { capitalize, startCase } from "lodash";
import { useTranslation } from "react-i18next";
import {
  usePutCountryMutation,
  usePutFirstNameMutation,
  usePutJobTitleMutation,
  usePutLastNameMutation,
} from "../api/profile.api";

export type ProfileKey = "firstName" | "lastName" | "jobTitle" | "country";
export type ProfileUpdateFunction = (
  key: ProfileKey,
  value: string
) => Promise<void>;

export const useMutations = () => {
  const { t } = useTranslation("translation", { keyPrefix: "profile" });
  const { addSnackbar } = useSnackbarContext();

  const [updateFirstName] = usePutFirstNameMutation();
  const [updateLastName] = usePutLastNameMutation();
  const [updateJobTitle] = usePutJobTitleMutation();
  const [updateCountry] = usePutCountryMutation();

  const mutate = async (key: ProfileKey, value: string) => {
    if (key === "firstName")
      return await updateFirstName({ firstNamePayload: { [key]: value } });
    if (key === "lastName")
      return await updateLastName({ lastNamePayload: { [key]: value } });
    if (key === "jobTitle")
      return await updateJobTitle({ jobTitlePayload: { [key]: value } });

    //if (key === "country")
    return await updateCountry({ countryCodePayload: { [key]: value } });
  };

  // TODO: Do we want to debounce this for 300ms like before?
  const updateProfileField: ProfileUpdateFunction = async (key, value) => {
    const response = await mutate(key, value);
    const fieldLabel = capitalize(startCase(key).toLowerCase());

    if (!response.error) {
      addSnackbar(
        t("form.success_message", {
          key: fieldLabel,
          id: `field-update-${fieldLabel}`,
        })
      );
    } else {
      addSnackbar(
        t("form.error_message", {
          key: fieldLabel.toLowerCase(),
          id: `field-update-error-${fieldLabel}`,
        }),
        {
          type: "error",
        }
      );
    }
  };

  return { updateProfileField };
};
